// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueQrcodeReader from "vue-qrcode-reader";
import VueCookie from "vue-cookie";
import VCalendar from 'v-calendar';
import JsonExcel from 'vue-json-excel'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// import source data
import routes from './routes/routes'
import config from './config/config'
import store from './store'

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import Notifications from './components/NotificationPlugin'

// MaterialDashboard plugin
import MaterialDashboard from './material-dashboard'
import 'vue-datetime/dist/vue-datetime.css'
import Chartist from 'chartist'

// merge resources to vue instance
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(Vuex)
Vue.use(VueQrcodeReader)
Vue.use(MaterialDashboard)
Vue.use(ElementUI)
Vue.use(GlobalComponents)
Vue.use(GlobalDirectives)
Vue.use(Notifications)
Vue.use(VueCookie);
Vue.use(VCalendar);

// create new vuex store
let VuexStore = new Vuex.Store(store);
// create new router
const router = new VueRouter({
	routes,
	mode: 'history',
	linkExactActiveClass: 'nav-item active'
})

Vue.component('downloadExcel', JsonExcel)
// setup authorization header and check token
Vue.http.interceptors.push((request, next) => {
	request.headers.set("Content-Type", "application/json");

	next((res) => {
		if (res.status === 200 && res.ok === true) {
			// switch (res.body.status) {
			// 	case 'expired':
			// 		VuexStore.state.authentication.authToken = null
			// 		VuexStore.state.authentication.loggedIn = false
			// 		break;
			// 	case 'fail':
			// 		Vue.prototype.$notification.notify({
			// 			message: res.body.message,
			// 			icon: 'error',
			// 			type: 'danger'
			// 		})
			// 		break;
			// 	case 'error':
			// 		Vue.prototype.$notification.notify({
			// 			message: "Something went wrong !",
			// 			icon: 'error',
			// 			type: 'danger'
			// 		})
			// 		break;
			// }
		} else if (res.ok === false) {
			// Vue.prototype.$notification.notify({
			// 	message: "Something went wrong or error with internet connection !",
			// 	icon: 'error',
			// 	type: 'danger'
			// })
		}

	})
})

// add config data to global
Vue.prototype.config = config

/* eslint-disable no-new */
new Vue({
	el: '#app',
	render: h => h(App),
	store: VuexStore,
	router
})



// WEBPACK FOOTER //
// ./src/main.js